import * as React from "react";
import { FieldError } from "react-hook-form";

type FormGroupContextValue = {
  error?: FieldError;
};

const FormGroupContext = React.createContext<FormGroupContextValue | undefined>(
  undefined
);

const useFormGroup = () => {
  const context = React.useContext(FormGroupContext);
  if (context === undefined) {
    throw new Error("useFormGroup must be used within a <FormGroup />");
  }

  return context;
};

export { FormGroupContext, useFormGroup };
